import React from 'react'
import { connect } from 'react-redux'
import { Flags } from 'react-feature-flags'
import { run, options } from 'django-task-api'
import Navigation from './Navigation'
import Details from './Details'
import { hideReport } from '../../actions/report'
import { morph } from '../../utils'
import IconArrowleft from '../../../img/icon-arrow-thick-left-circle.svg'
import IconCloudDownload from '../../../img/icon-cloud-download.svg'
import { createReportData } from './utils'
import IconQuestion from '../../../img/icon-question.svg'
import IconCheck from '../../../img/icon-check.svg'
import CloseIcon from '../../../img/icon-close-circle.svg'
import { setDialog as setDialogConnect } from '../../actions/navigation'
import { post } from '../Accounts/API'

options.csrfHeaderName = 'X-CSRFToken'

class Report extends React.Component {
    static getDerivedStateFromProps({ items }, { active }) {
        const primaryItems = items
            .filter(item => item.parent === null)
            .map(item => morph(item, { children: items.filter(i => item.type === 'project' && i.parent === item.id) }))
        const activeItem = primaryItems[0]

        return {
            items: primaryItems,
            active: active === null || !primaryItems.find(item => item.id === active) ? activeItem.id : active
        }
    }

    componentDidMount() {
        const { items } = this.props
        post('/analyze/', { parcels: items.filter(item => item.type === 'parcel').map(item => item.id) })
            .then(response => {
                this.setState({ data: response.data, isLoading: false })
            })
            .catch(() => this.props.onClose())

        window.document.body.addEventListener('click', this.onBodyClick)
    }

    componentWillUnmount() {
        window.document.body.removeEventListener('click', this.onBodyClick)
    }

    constructor(props) {
        super(props)
        this.state = {
            items: [],
            active: null,
            data: null,
            isLoading: true,
            showDownloadMenu: false,
            isDownloading: false,
            showFeedback: false
        }

        this.downloadRef = React.createRef()
    }

    onBodyClick = e => {
        const { showDownloadMenu } = this.state
        if (!showDownloadMenu || this.downloadRef.current.contains(e.target)) {
            return
        }

        this.setState({ showDownloadMenu: false, isReportLoading: false })
    }

    downloadReport = include => {
        const { items, data } = this.state
        const timezoneOffset = (new Date().getTimezoneOffset() / 60) * -1
        const taskData = { include, timezone_offset: timezoneOffset, ...createReportData(items, data, include) }

        this.setState({ isReportLoading: true, showFeedback: true })

        run('generate-report', taskData)
            .then(result => {
                this.setState({ isReportLoading: false, showDownloadMenu: false })

                const { download_link: downloadLink } = result.outputs
                const parts = downloadLink.split('/')
                const node = document.createElement('a')
                node.href = downloadLink
                node.download = parts[parts.length - 1]
                node.click()
            })
            .catch(ex => {
                this.setState({ isReportLoading: false, showDownloadMenu: false })
                console.error(ex)
            })
    }

    render() {
        const { onClose, setDialog } = this.props
        const { items, active, data, isLoading, showDownloadMenu, showFeedback } = this.state

        if (isLoading) {
            return (
                <div className="report loading">
                    <div className="spinner">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                    </div>
                </div>
            )
        }

        let reportData = null
        if (Object.keys(data).length > 0) {
            reportData = createReportData(items, data, 'all', false)
        }

        return (
            <div className="report">
                <div className="report-modal">
                    <header className="report-header">
                        <div className="columns is-mobile">
                            <div className="column is-narrow">
                                <button onClick={onClose} onKeyDown={e => (e.key === 'Enter' ? onClose() : null)}>
                                    <span className="svg-icon icon-24 header-icon">
                                        <IconArrowleft />
                                    </span>{' '}
                                    Back
                                </button>
                            </div>
                            <div className="has-text-weight-bold has-text-centered column is-hidden-touch">
                                Site Check Report
                            </div>
                            <div className="column is-hidden-desktop" />
                            <div className="column is-narrow">
                                <button className="is-hidden-mobile" onClick={() => setDialog('feedback')}>
                                    Feedback
                                </button>
                            </div>

                            <div className="column is-narrow" ref={this.downloadRef}>
                                {reportData ? (
                                    <a
                                        onClick={() => {
                                            this.setState({ showDownloadMenu: !showDownloadMenu })
                                        }}
                                    >
                                        {' '}
                                        {/* Todo: change to button after a11y changes are merged */}
                                        <span className="svg-icon icon-24 header-icon">
                                            <IconCloudDownload />
                                        </span>{' '}
                                        Download
                                        <span className="triangle expanded right is-white" />
                                    </a>
                                ) : null}
                                {showDownloadMenu && (
                                    <div className="download-menu">
                                        {this.state.isReportLoading && (
                                            <div className="loading-background">
                                                <div className="spinner">
                                                    <div className="bounce1" />
                                                    <div className="bounce2" />
                                                    <div className="bounce3" />
                                                </div>
                                            </div>
                                        )}
                                        <h6 className="title is-6">Download the following:</h6>
                                        <ul>
                                            <li>
                                                <a onClick={() => this.downloadReport('all')}>
                                                    <span className="svg-icon icon-24 svg-primary-primary svg-secondary-white">
                                                        <IconCheck />
                                                    </span>
                                                    ,{' '}
                                                    <span className="svg-icon icon-24 svg-primary-accent svg-secondary-white">
                                                        <IconQuestion />
                                                    </span>
                                                    , and{' '}
                                                    <span className="svg-icon icon-24 svg-primary-danger-light svg-secondary-white">
                                                        {/* <SVGWrapper title="X"> */}
                                                        <CloseIcon width={20} height={20} />
                                                        {/* </SVGWrapper> */}
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a onClick={() => this.downloadReport('possible')}>
                                                    <span className="svg-icon icon-24 svg-primary-primary svg-secondary-white">
                                                        <IconCheck />
                                                    </span>
                                                    ,{' '}
                                                    <span className="svg-icon icon-24 svg-primary-accent svg-secondary-white">
                                                        <IconQuestion />
                                                    </span>{' '}
                                                    Only
                                                </a>
                                            </li>
                                            <li>
                                                <a onClick={() => this.downloadReport('potential')}>
                                                    <span className="svg-icon icon-24 svg-primary-primary svg-secondary-white">
                                                        <IconCheck />
                                                    </span>{' '}
                                                    Only
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </header>
                    <div className="columns">
                        {reportData ? (
                            <>
                                <Navigation
                                    items={reportData.items}
                                    active={active}
                                    scrollTo={id =>
                                        document
                                            .getElementById(id)
                                            .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
                                    }
                                />
                                <div className="column report-content">
                                    <Details
                                        items={reportData.items}
                                        active={active}
                                        setActive={active => this.setState({ active })}
                                        setDialog={setDialog}
                                        showFeedback={showFeedback}
                                    />
                                </div>
                            </>
                        ) : (
                            <div className="no-data">
                                No exemptions or requirements were found in the parcel(s) you selected.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    ({ parcels: { items } }) => ({ items }),
    dispatch => ({
        onClose: () => dispatch(hideReport()),
        setDialog: dialogName => {
            dispatch(setDialogConnect(dialogName))
        }
    })
)(Report)
